import React, {useRef, useState} from 'react';
import buttonClose from "../../../assets/images/shared/modals/button-close.svg";
import SignatureCanvas from "react-signature-canvas"

const ModalSignature = ({ showModalSignature, closeModalSignature, onSaveSignature }) => {
  const sigCanvas = useRef(null);

  const clearSignature = () => {
      sigCanvas.current.clear();
  }
  //Guardar la firma como imagen 
  const saveSignature = () => {
    const signatureDataURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    onSaveSignature(signatureDataURL);
    closeModalSignature();
  };

  if (!showModalSignature) return null; 
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="md:w-[482px] md:h-[276px] w-[320px] h-[280px] bg-white rounded-3xl shadow-lg flex flex-col  ">
        <div className='flex justify-end'>
          <button
            onClick={closeModalSignature}
            className="px-4 py-2 rounded-md"
          >
            <img src={buttonClose} alt="Cerrar"/>
          </button>
        </div>
        <div className='flex flex-col items-center justify-center'>
            <SignatureCanvas className="p-5 "
                ref={sigCanvas}
                penColor="black"
                canvasProps={{
                    width: 280,
                    height: 170,
                    className: "signature-canvas border border-gray rounded"
                }}
            />
            <div className="flex justify-between mt-4 mb-2 w-[280px]">
                <button
                    className="px-4 py-1 text-xs text-white rounded-lg font-itcbook bg-red"
                    onClick={clearSignature}
                >
                    Limpiar
                </button>
                <button
                    className="px-4 py-1 text-xs text-white rounded-lg font-itcbook bg-green"
                    onClick={saveSignature}
                    >
                    Guardar
                </button>
            </div>
        </div>
      </div>
    </div>
  );
};
export default ModalSignature;
